import { ROUTE_UI_SECTION_NAME } from '../../../constants/route'

import AppointmentIcon from '../../../icons/activities/calendar.svg'
import DocFlowIcon from '../../../icons/doc-splitting.svg'
import EmailIcon from '../../../icons/email.svg'
import FolderIcon from '../../../icons/folder.svg'
import InvoiceIcon from '../../../icons/invoice.svg'
import PostIcon from '../../../icons/post.svg'
import ServiceRequestIcon from '../../../icons/service-request.svg'
import ActivityIcon from '../../../icons/task.svg'
import UploadIcon from '../../../icons/upload-1.svg'

export const REQUEST_PROFILE_HEADER_FOOTER_ACTION = {
  activity: 'activity',
  appointment: 'appointment',
  chat: 'chat',
  docFlow: 'docFlow',
  email: 'email',
  folder: 'folder',
  invoice: 'invoice',
  post: 'post',
  serviceRequest: 'serviceRequest',
  upload: 'upload',
}

export const REQUEST_PROFILE_HEADER_FOOTER_ACTION_TEXT_KEY = {
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.activity]:
    'RequestProfile.HeaderFooterActivityButtonKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.appointment]:
    'Appointment.ScheduleFromRequestKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.chat]:
    'RequestProfile.HeaderFooterChatButtonKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.docFlow]:
    'RequestProfile.HeaderFooterDocFlowButtonKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.email]:
    'RequestProfile.HeaderFooterEmailButtonKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.folder]:
    'RequestProfile.HeaderFooterFolderButtonKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.invoice]:
    'RequestProfile.HeaderFooterInvoiceButtonKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.post]:
    'RequestProfile.HeaderFooterPostButtonKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.serviceRequest]:
    'RequestProfile.HeaderFooterServiceRequestButtonKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.upload]:
    'RequestProfile.HeaderFooterUploadButtonKey',
}

export const REQUEST_PROFILE_HEADER_FOOTER_ACTION_QA_NAME = {
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.activity]:
    'requestProfileHeaderActionActivity',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.appointment]:
    'requestProfileHeaderActionAppointment',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.chat]: 'requestProfileHeaderActionChat',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.docFlow]:
    'requestProfileHeaderActionDocFlow',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.email]:
    'requestProfileHeaderActionEmail',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.folder]:
    'requestProfileHeaderActionFolder',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.invoice]:
    'requestProfileHeaderActionInvoice',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.post]: 'requestProfileHeaderActionPost',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.serviceRequest]:
    'requestProfileHeaderActionServiceRequest',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.upload]:
    'requestProfileHeaderActionUpload',
}

export const REQUEST_PROFILE_HEADER_FOOTER_ACTION_PERMISSION = {
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.activity]: 'can_add_activity',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.docFlow]:
    'can_view_connected_document_staplings',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.email]: 'can_send_email_message',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.folder]: 'can_add_file',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.invoice]: 'can_add_budget_plan',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.post]: 'can_create_post',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.serviceRequest]:
    'can_create_related_request',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.upload]: 'can_add_file',
}

// Actions that also need the init-data section with `can_create` (the entity
// lives outside the request).
export const REQUEST_PROFILE_HEADER_FOOTER_ACTION_SECTION = {
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.docFlow]:
    ROUTE_UI_SECTION_NAME.docFlows,
}

export const REQUEST_PROFILE_HEADER_FOOTER_DOC_FLOW_OPTION = {
  connect: 'connect',
  create: 'create',
}

export const REQUEST_PROFILE_HEADER_FOOTER_DOC_FLOW_OPTIONS = [
  {
    label: 'RequestProfile.HeaderFooterDocFlowAddNewOptionKey',
    value: REQUEST_PROFILE_HEADER_FOOTER_DOC_FLOW_OPTION.create,
  },
  {
    label: 'RequestProfile.HeaderFooterDocFlowConnectOptionKey',
    value: REQUEST_PROFILE_HEADER_FOOTER_DOC_FLOW_OPTION.connect,
  },
]

export const REQUEST_PROFILE_HEADER_FOOTER_QA_NAME = {
  addNew: 'profileAddNew',
  more: 'profileMore',
}

export const REQUEST_PROFILE_HEADER_FOOTER_BAR_BORDERS_WIDTH = 2

export const REQUEST_PROFILE_HEADER_FOOTER_ACTION_ITEMS = [
  {
    Icon: EmailIcon,
    action: REQUEST_PROFILE_HEADER_FOOTER_ACTION.email,
  },
  {
    Icon: ActivityIcon,
    action: REQUEST_PROFILE_HEADER_FOOTER_ACTION.activity,
  },
  {
    Icon: AppointmentIcon,
    action: REQUEST_PROFILE_HEADER_FOOTER_ACTION.appointment,
  },
  {
    Icon: PostIcon,
    action: REQUEST_PROFILE_HEADER_FOOTER_ACTION.post,
  },
  // {
  //   Icon: ChatIcon,
  //   action: REQUEST_PROFILE_HEADER_FOOTER_ACTION.chat, // TODO add chat action when it will be needed
  // },
  {
    Icon: ServiceRequestIcon,
    action: REQUEST_PROFILE_HEADER_FOOTER_ACTION.serviceRequest,
  },
  {
    Icon: DocFlowIcon,
    action: REQUEST_PROFILE_HEADER_FOOTER_ACTION.docFlow,
  },
  {
    Icon: InvoiceIcon,
    action: REQUEST_PROFILE_HEADER_FOOTER_ACTION.invoice,
  },
  {
    Icon: FolderIcon,
    action: REQUEST_PROFILE_HEADER_FOOTER_ACTION.folder,
  },
  {
    Icon: UploadIcon,
    action: REQUEST_PROFILE_HEADER_FOOTER_ACTION.upload,
  },
]
